import React from 'react';
import * as Yup from 'yup';

import Input from 'components/Input';
import type { TFunction } from 'i18n/I18nContext';
import { useI18n } from 'i18n/I18nContext';

export interface LocationFormProps {
  errors?: Partial<Record<string, string>>;
  t?: TFunction;
}

const LocationForm = ({ errors, t: tProp }: LocationFormProps) => {
  const { t: tCtx } = useI18n();
  const t = tProp ?? tCtx;
  return (
    <div className="gb-onboard-step">
      <header className="gb-onboard-intro">
        <h1 className="gb-onboard-panel__title">{t('forms.businessTitle')}</h1>
        <p className="gb-onboard-panel__lede-text">{t('forms.businessLede')}</p>
      </header>

      <div className="gb-onboard-fields">
        <Input
          label={t('forms.businessName')}
          type="text"
          name="locationName"
          autoComplete="organization"
          error={errors?.locationName}
        />

        <Input
          label={t('forms.address')}
          type="text"
          name="address"
          autoComplete="street-address"
          error={errors?.address}
        />

        <div className="gb-onboard-fields__row">
          <Input
            label={t('forms.city')}
            type="text"
            name="city"
            autoComplete="address-level2"
            error={errors?.city}
          />

          <Input
            label={t('forms.postalCode')}
            type="text"
            name="zip"
            autoComplete="postal-code"
            hint={t('forms.postalHint')}
            error={errors?.zip}
          />
        </div>

        <Input
          label={t('forms.phone')}
          type="tel"
          name="phone"
          autoComplete="tel"
          inputMode="tel"
          hint={t('forms.phoneHint')}
          error={errors?.phone}
        />
      </div>
    </div>
  );
};

function validationSchema(t: TFunction) {
  return Yup.object().shape({
    locationName: Yup.string().required(t('forms.valBusinessRequired')),

    address: Yup.string().required(t('forms.valAddressRequired')),

    city: Yup.string().required(t('forms.valCityRequired')),

    zip: Yup.string()
      .test(
        'regex',
        t('forms.valZipFormat'),
        (zip: string | undefined) => !!(zip || '').match(/[0-9]{4}[ ]?[a-z]{2}/i)
      )
      .required(t('forms.valZipRequired')),

    phone: Yup.string().required(t('forms.valPhoneRequired')).min(8, t('forms.valPhoneMin')),
  });
}

const LocationFormExport = LocationForm as typeof LocationForm & {
  validationSchema: typeof validationSchema;
};
LocationFormExport.validationSchema = validationSchema;

export default LocationFormExport;



// WEBPACK FOOTER //
// ./src/components/forms/LocationForm.tsx